<template>
  <div class="cancel-subscription">
    <mds-modal
      size="small"
      width="600px"
      aria-label="Small Modal"
      v-model="openCancelSubscriptionModal"
    >
      <div class="cancel-subcription-modal-container">
        <div class="cancel-subcription-content-wrapper">
          <div class="cancel-subcription-heading">
            <h1>We're sorry to see you go. Let us know why you're canceling.</h1>
          </div>
          <div class="cancel-subcription-end-date">
            <h3>Your subscription will end on {{ subscriptionEndDate | formatDateWithDotAfterMonth }}.</h3>
          </div>
          <div class="cancel-subcription-disclaimer">
            <p>
              Upon cancellation, any remaining prepaid charges will be refunded to your credit card.
            </p>
          </div>
          <div class="cancel-subcription-modal-border-seperator"></div>
          <div class="cancel-subscription-modal-radio-button-container">
            <mds-form>
              <mds-radio-button
                class="cancel-subscription-modal-radio-buttons"
                v-for="(radioButtons, index) in cancelSubscriptionRadioButtons"
                :key="index"
                name="selected-example"
                :value="radioButtons.text"
                v-model="radioButtonSelected"
                >{{ radioButtons.text }}</mds-radio-button
              >
            </mds-form>
          </div>
          <div
            class="cancel-subcription-modal-border-seperator"
            v-if="displayMessage != null"
          ></div>
          <div
            class="cancel-subcription-modal-option-selected-message"
            v-html="displayMessage"
          ></div>
          <div class="cancel-subscription-action-button-container">
            <mds-button-container right-aligned>
              <mds-button @click="resetModalStatus()" size="medium" variation="secondary"
                >Don’t Cancel</mds-button
              >
              <mds-button
                @click="cancelSubscription()"
                size="medium"
                variation="primary"
                :disabled="disableCancelButton"
                >Cancel Subscription</mds-button
              >
            </mds-button-container>
          </div>
        </div>
      </div>
    </mds-modal>
  </div>
</template>

<script lang="js">
import MdsModal from '@mds/modal';
import MdsForm from '@mds/form';
import MdsRadioButton from '@mds/radio-button';
import { MdsButton, MdsButtonContainer } from '@mds/button';
import { postData } from "@/utilities/API/apiUtility";
  export default  {
    name: 'cancel-subscription',
    props: {
      cancelSubscriptionData:{
        type: Object,
        required: true,
      },
    },
    components:{
      MdsModal,
      MdsForm,
      MdsRadioButton,
      MdsButton,
      MdsButtonContainer
    },
    mounted () {
      this.convertProductNameToCode();
    },
    data () {
      return {
        cancelSubscriptionURL : process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_CANCEL_SUBSCRIPTION,
        productName: this.cancelSubscriptionData.product,
        subscriptionEndDate:new Date(),
        openCancelSubscriptionModal:this.cancelSubscriptionData.modalStatus,
        userID:this.cancelSubscriptionData.userID, // GUID - UIM
        SubscriptionId:this.cancelSubscriptionData.StripeSubscriptionId,
        productCode:null,
        cancelSubscriptionRadioButtons:[
          {
            id: 0,
            text: "Service did not meet my needs",
            description: {
              message: {
                mfi: `<p>Before you go, we’d like to ensure you’re aware of everything available with your FundInvestor subscription. With FundInvestor, you get exclusive access to our independent research and analysis, our FundInvestor 500 coverage of the most popular mutual funds, the FundInvestor Selector Tool, and so much more. Check out our <a href="/assets/SubscriberHandbooks/MFI_Handbook_1224.pdf" target="_blank">Subscriber’s Handbook</a> for an overview of all of FundInvestor’s features.</p>`,
                msi: `<p>Before you go, we’d like to ensure you’re aware of everything available with your StockInvestor subscription. With StockInvestor, you get exclusive access to our independent research and analysis, real-money portfolios and their strategy-driven watchlist, ongoing editor commentary, and so much more. Check out our <a href="/assets/SubscriberHandbooks/MSI_Handbook_1123.pdf" target="_blank">Subscriber’s Handbook</a> for an overview of all of StockInvestor’s features.</p>`,
                mdi: `<p>Before you go, we’d like to ensure you’re aware of everything available with your DividendInvestor subscription. With DividendInvestor, you get exclusive access to our independent research and analysis, real-money portfolio and its strategy-driven watchlist, ongoing editor commentary, and so much more. Check out our <a href="/assets/SubscriberHandbooks/MDI_Handbook_1224.pdf" target="_blank">Subscriber’s Handbook</a> for an overview of all of DividendInvestor’s features.</p>`,
                mei: `<p>Before you go, we’d like to ensure you’re aware of everything available with your ETFInvestor subscription. With ETFInvestor, you get exclusive access to our independent research and analysis, model portfolios and their strategy-driven watchlists, ongoing editor commentary, and so much more. Check out our <a href="/assets/SubscriberHandbooks/MEI_Handbook_1123.pdf" target="_blank">Subscriber’s Handbook</a> for an overview of all of ETFInvestor’s features.</p>`
              }
            }
          },
          {
            id:1,
            text:"Receiving information from another source",
            description:"<p>We know you rely on multiple sources for your investment research—but are you sure you want to cancel? Your subscription gives you access to proprietary portfolios and watchlists that are hand-picked by Morningstar’s editors and portfolio managers. This information isn’t available anywhere else, and it can be a valuable complement to other resources you may consult.</p>",
          },
          {
            id:2,
            text:"Did not use the service enough",
            description:{
              message:{
                mfi:"<p>We’re sorry to see you go. Before you do, we’d like to double-check that you’re aware of all the features included with your FundInvestor subscription, which include:</p>"
                +"<ul><li>Access to our exclusive one-page fund reports</li>"
                +"<li>Our FundInvestor 500 list of the most popular mutual funds</li>"
                +"<li>Exclusive use of the FundInvestor Selector tool, which includes our Medalist Ratings and other criteria to help you evaluate a fund’s performance</li></ul>"
                +`<p>To review a complete list of features, check out the FundInvestor <a href="/assets/SubscriberHandbooks/MFI_Handbook_1224.pdf" target="_blank">Subscriber’s Handbook</a>.</p>`,

                msi:"<p>We’re sorry to see you go. Before you do, we’d like to double-check that you’re aware of all the features included with your StockInvestor subscription, which include:</p>"
                +"<ul><li>Exclusive access to our independent research and analysis</li>"
                +"<li>Regular commentary from our editors, sent straight to your inbox</li>"
                +"<li>Real-money portfolios and its strategy-driven watchlist</li></ul>"
                +`<p>To review a complete list of features, check out the <a href="/assets/SubscriberHandbooks/MSI_Handbook_1123.pdf" target="_blank">Subscriber’s Handbook</a>.</p>`,

                mdi:"<p>We’re sorry to see you go. Before you do, we’d like to double-check that you’re aware of all the features included with your DividendInvestor subscription, which include:</p>"
                +"<ul><li>Exclusive access to our independent research and analysis</li>"
                +"<li>Regular commentary from our editors, sent straight to your inbox</li>"
                +"<li>Real-money portfolio and its strategy-driven watchlist</li></ul>"
                +`<p>To review a complete list of features, check out the DividendInvestor <a href="/assets/SubscriberHandbooks/MDI_Handbook_1224.pdf" target="_blank">Subscriber’s Handbook</a>.</p>`,

                mei:"<p>We’re sorry to see you go. Before you do, we’d like to double-check that you’re aware of all the features included with your ETFInvestor subscription, which include:</p>"
                +"<ul><li>Exclusive access to our independent research and analysis</li>"
                +"<li>Regular commentary from our editor, sent straight to your inbox</li>"
                +"<li>Model portfolios and their strategy-driven watchlists</li></ul>"
                +`<p>To review a complete list of features, check out the ETFInvestor <a href="/assets/SubscriberHandbooks/MEI_Handbook_1123.pdf" target="_blank">Subscriber’s Handbook</a>.</p>`,
              }
            },
            checked:false
          },
          {
            id:3,
            text:"No Longer investing in the market",
            description:"<p>Are you sure you want to cancel? Even if you aren’t actively tending your portfolio at this time, keeping up with our editors’ insights on market trends can help you reach your financial goals in the long term.</p>",
            checked:false
          },
          {
            id:4,
            text:"Service was too expensive",
            description:{
              message:{
                mfi:"<p>Before you go, we want to be sure you’re aware that FundInvestor delivers essential tools and strategies to help you build a durable portfolio. With your subscription, you get:</p>"
                +"<ul><li>Access to our exclusive fund reports</li>"
                +"<li>Exclusive use of the FundInvestor Selector tool, which includes our Medalist Ratings and other criteria to help you evaluate a fund’s performance</li>"
                +"<li>Our FundInvestor 500 list of the most popular mutual funds</li>"
                +"<li>Ongoing editor commentary</li></ul>"
                +`<p>For a complete review of everything you’ll lose access to if you cancel, check out the FundInvestor <a href="/assets/SubscriberHandbooks/MFI_Handbook_1224.pdf" target="_blank">Subscriber’s Handbook</a>.</p>`,

                msi:"<p>We’re sorry to see you go. Before you do, we’d like to double-check that you’re aware of all the features included with your StockInvestor subscription, which include:</p>"
                +"<ul><li>Exclusive access to our independent research and analysis</li>"
                +"<li>Insights from real-money portfolios and their strategy-driven watchlist</li>"
                +"<li>Commentary on current events relevant to our strategies</li></ul>"
                +`<p>For a complete review of everything you’ll lose access to if you cancel, check out the StockInvestor <a href="/assets/SubscriberHandbooks/MSI_Handbook_1123.pdf" target="_blank">Subscriber’s Handbook</a>.</p>`,

                mdi:"<p>We’re sorry to see you go. Before you do, we’d like to double-check that you’re aware of all the features included with your DividendInvestor subscription, which include:</p>"
                +"<ul><li>Exclusive access to our independent research and analysis</li>"
                +"<li>Our real-money portfolio and its strategy-driven watchlist</li>"
                +"<li>Commentary on current events relevant to our strategies</li></ul>"
                +`<p>For a complete review of everything you’ll lose access to if you cancel, check out the DividendInvestor <a href="/assets/SubscriberHandbooks/MDI_Handbook_1224.pdf" target="_blank">Subscriber’s Handbook</a>.</p>`,

                mei:"<p>Before you go, we want to be sure you’re aware that ETFInvestor delivers essential tools and strategies to help you build a durable portfolio. With your subscription, you get:</p>"
                +"<ul><li>Exclusive access to our independent research and analysis</li>"
                +"<li>Insights from our six model portfolios, each with a different strategic focus</li>"
                +"<li>A watchlist of ETFs that may fit the model portfolios’ investment mandates</li>"
                +"<li>Ongoing editor commentary</li></ul>"
                +`<p>For a complete review of everything you’ll lose access to if you cancel, check out the ETFInvestor <a href="/assets/SubscriberHandbooks/MEI_Handbook_1123.pdf" target="_blank">Subscriber’s Handbook</a>.</p>`,
              }
            },
          },
          {
            id:5,
            text:"Other",
            description:"<p>Before you go, we’d like to ensure you get any product-related questions and issues answered. Please feel free to contact our support team at 1-312-424-4288 or <a href='mailto:newslettersupport@morningstar.com'>newslettersupport@morningstar.com.</a><p>"
          }
        ],
        radioButtonSelected:null,
        displayMessage:null,
        disableCancelButton:true,
        noSelection:true,
        cancellationReason:null,
      }
    },
    methods: {
      convertProductNameToCode(){
        this.productCode = this.productName.substring(0, this.productName.indexOf(' '));
        switch(this.productCode){
          case "FundInvestor" : this.productCode='mfi';break;
          case "StockInvestor" : this.productCode='msi';break;
          case "DividendInvestor" : this.productCode='mdi';break;
          case "ETFInvestor" : this.productCode='mei';break;
        }
      },
      resetModalStatus() {
        this.openCancelSubscriptionModal = false;
        this.$emit('resetCancelSubscriptionModalValue', false);
      },
      CancelSubScriptionRadioButtonSelection(text){
        for(let i=0;i < this.cancelSubscriptionRadioButtons.length;i++){
           if(this.cancelSubscriptionRadioButtons[i].text == text){
             if(i == 1 || i == 3 || i == 5){
               this.displayMessage = this.cancelSubscriptionRadioButtons[i].description;
             }else{
                this.displayMessage = this.cancelSubscriptionRadioButtons[i].description.message[this.productCode];
             }
             this.cancellationReason = this.cancelSubscriptionRadioButtons[i].text;
           }
        }

      },
      async cancelSubscription() {
        this.disableCancelButton = true;
        const CANCEL_ERROR_MSG = "There was an issue while canceling your subscription. Please try again.";
        const REFUND_ERROR_MSG = "We were unable to process your refund. Please contact customer support for assistance at 1-800-957-6021.";

        const getErrorMessage = (isCancelled) =>
        isCancelled ? REFUND_ERROR_MSG : CANCEL_ERROR_MSG;

        if (this.noSelection) {
            this.showAlert("Please select a reason before cancelling the subscription.", false, true);
        } else {
            const response = await postData(this.cancelSubscriptionURL, {
              SubscriptionId: this.SubscriptionId,
            });
            
            if (response.status === 200) {
              if (response.data.isCancelled && response.data.isRefunded) {
                this.handleCancellationSuccess();
              } else {
                this.handleCancellationError(getErrorMessage(response.data.isCancelled));
              }
            } else {
              this.handleCancellationError(getErrorMessage(response.data.isCancelled));
            }
            this.resetModalStatus();
        }
      },

      handleCancellationSuccess() {
          this.showAlert("Your subscription has been canceled. Restart your subscription at any time by visiting our homepage.", true, false);
          this.$gtag.event('download_pdf', {
              'cancel_reason': this.cancellationReason,
              'User Id': this.userID,
              'product': this.productCode
          });
          this.disableCancelButton = false;
          this.$emit('subscriptionCancellationStatusValue', true);
      },

      handleCancellationError(message) {
          this.showAlert(message, false, true);
          this.disableCancelButton = false;
          this.$emit('subscriptionCancellationStatusValue', false);
      },

      showAlert(message, successAlertStatus, errorAlertStatus) {
        this.$store.state.product.SuccessAlert = successAlertStatus;
        this.$store.state.product.ErrorAlert = errorAlertStatus;
        this.$store.state.product.lstAlertMsg.length = 0;
        this.$store.state.product.lstAlertMsg.push(message);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }

    },
    computed: {

    },
    watch:{
      radioButtonSelected(){
        this.disableCancelButton=false;
        this.noSelection=false;
        this.CancelSubScriptionRadioButtonSelection(this.radioButtonSelected);
      },
      openCancelSubscriptionModal(){
        this.resetModalStatus();
      }
    }
}
</script>

<style scoped>
@media only screen and (min-width: 480px) {
  .cancel-subcription-modal-container {
    width: 100%;
    padding: 24px;
    overflow-y: scroll;
  }

  .cancel-subscription-action-button-container {
    margin-top: 20px;
  }
}

@media only screen and (max-width: 480px) {
  .cancel-subcription-modal-container {
    width: 100%;
    padding-top: 21px;
    padding-left: 13px;
    padding-right: 13px;
    padding-bottom: 11px;
    overflow-y: scroll;
  }
}

.cancel-subcription-modal-container::-webkit-scrollbar {
  height: 6px;
  width: 6px;
  overflow-x: overlay;
}

.cancel-subcription-modal-container::-webkit-scrollbar-thumb {
  background: rgba(171, 171, 171, 0.3);
  border-radius: 6px;
}
.cancel-subcription-content-wrapper {
  width: 100%;
}
.cancel-subcription-heading h1 {
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: 27px;
  color: #000000;
}
.cancel-subcription-end-date h3 {
  margin-top: 8px;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: 22px;
  color: #000000;
}
.cancel-subcription-disclaimer {
  margin-top: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #000000;
}
.cancel-subcription-modal-border-seperator {
  height: 1px;
  background: #e5e5e5;
  margin: 20px 0;
}
.cancel-subscription-modal-radio-buttons {
  margin-bottom: 10px;
}
.cancel-subcription-modal-option-selected-message {
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 21px;
  color: #000000;
}
</style>
<style>
.cancel-subcription-modal-option-selected-message ul {
  padding-left: 20px;
  margin: 10px 0px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #1e1e1e;
}
.cancel-subcription-modal-option-selected-message a {
  color: #000000;
  text-decoration-line: underline;
  cursor: pointer;
}
.cancel-subscription-modal-radio-buttons .mds-radio-button__visible-wrap {
  box-shadow: none !important;
}
@media only screen and (max-width: 480px) {
  .cancel-subscription-action-button-container {
    margin-top: 20px;
  }

  .cancel-subscription-action-button-container > div > button > span {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1600px) {
.cancel-subscription>div>div{
  margin-left: -3%;
}
}

@media only screen and (min-width: 1600px) {
.cancel-subscription>div>div{
  margin-left: 0%;
}
}

.cancel-subscription>div{
     background: rgba(0, 0, 0, 0.5);
    transition: opacity 0.5s ease-out;
    visibility: visible;
    
}
</style>